import { Skeleton } from 'ui/skeleton';

import { AlertHistoryCard, AlertHistoryList } from './AlertHistory.styled';
import { AlertHistoryItem } from './AlertHistoryItem';

export const AlertHistorySkeleton = () => {
  return (
    <AlertHistoryCard withPadding={false}>
      <AlertHistoryList>
        {new Array(4).fill(null).map((_, index) => (
          <AlertHistoryItem
            key={index}
            hoverable={false}
            label={<Skeleton height={20} width={272} isRound />}
            caption={<Skeleton height={16} width={162} isRound />}
          />
        ))}
      </AlertHistoryList>
    </AlertHistoryCard>
  );
};
